import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/fr/admin')({
  component: Outlet,
})
